import { gql } from '@apollo/client';

import { documentFragment } from '../fragments';

export default gql`
  mutation UpdateDocument(
    $courseId: String!
    $subjectId: String!
    $documentId: String!
    $input: UpdateDocumentInput!
  ) {
    document(
      courseId: $courseId
      subjectId: $subjectId
      documentId: $documentId
      input: $input
    )
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents/{args.documentId}"
        method: "PUT"
      ) {
      ...Document
    }
  }
  ${documentFragment}
`;
